import { CSSProperties, ReactNode } from 'react';

import DropdownButtonSelect from '@/shared/components/dropdowns/DropdownButton/DropdownButtonSelect';

export interface ScheduleDropdownOption<T extends string> {
    description?: string;
    dividerBefore?: boolean;
    icon: ReactNode;
    label: string;
    value: T;
}

interface ScheduleOptionDropdownProps<T extends string> {
    disabled?: boolean;
    footer?: ReactNode;
    maxHeight?: CSSProperties['maxHeight'];
    menuWidth?: CSSProperties['width'];
    onChange: (value: T) => void;
    options: Array<ScheduleDropdownOption<T>>;
    searchPlaceholder?: string;
    searchable?: boolean;
    size?: 'small' | 'middle' | 'large';
    value: T;
}

const ScheduleOptionDropdown = <T extends string>({
    disabled,
    footer,
    maxHeight = 16 * 18,
    menuWidth,
    onChange,
    options,
    searchPlaceholder = 'Search...',
    searchable,
    size,
    value,
}: ScheduleOptionDropdownProps<T>) => (
    <DropdownButtonSelect
        disabled={disabled}
        footer={footer}
        maxHeight={maxHeight}
        menuWidth={menuWidth}
        options={options}
        searchable={searchable}
        searchPlaceholder={searchPlaceholder}
        size={size}
        value={value}
        onChange={(nextValue) => {
            if (nextValue !== undefined) {
                onChange(nextValue);
            }
        }}
    />
);

export default ScheduleOptionDropdown;
